import { z } from "zod";

/**
 * EventoSchema
 */

export const EventoSchema = z.object({
  idItemVerba: z.number(),
  valor: z.coerce.number(),
  descricao: z.string().nullable().default(null),
});

/**
 * EventoForm
 */

export type EventoForm = z.infer<typeof EventoSchema>;